import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'ai-tool', {
    artifacts: 'Display artifact',
    artifactsReasoning: 'Displaying artifact',
    artifactsOutput: 'Displayed artifact',
    artifactsError: 'Error displaying artifact',
  });
}
